import React, { Fragment, useEffect, useState } from "react";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import { Link } from "react-router-dom";
import {
    ContainerApp,
    CustomizedCard,
    CustomizedCardBody,
    Icon,
    TitleCard
} from "./style";
import AuthService from "../../services/auth-service/AuthService";
import Loading from "../../components/loading/Loading";

const SettingsView = () => {
    const [name, setName] = useState("");
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        async function findUser() {
            try {
                setIsFetching(true);
                const decodedToken = await AuthService.getDecodedToken();
                setName(decodedToken.name);
            } catch (e) {
                console.log("error: ", e);
            } finally {
                setIsFetching(false);
            }
        }
        findUser();
    }, []);

    return (
        <React.Fragment>
            <CustomizedCard>
                {isFetching ? (
                    <Loading />
                ) : (
                    <Fragment>
                        <CustomizedCardHeader
                            className={"border-bottom"}
                            initialName={`Usuário: ${name}`}
                        />
                        <CustomizedCardBody>
                            <Link
                                to={{
                                    pathname: "/settings/reset-password",
                                    state: { name: name }
                                }}
                            >
                                <ContainerApp>
                                    <Icon className="material-icons">
                                        autorenew
                                    </Icon>
                                    <TitleCard>Alterar senha</TitleCard>
                                </ContainerApp>
                            </Link>
                            <Link
                                to={{
                                    pathname: "/settings/manager-credential",
                                    state: { name: name }
                                }}
                            >
                                <ContainerApp>
                                    <Icon className="material-icons">
                                        password
                                    </Icon>
                                    <TitleCard>Credenciais</TitleCard>
                                </ContainerApp>
                            </Link>
                        </CustomizedCardBody>
                    </Fragment>
                )}
            </CustomizedCard>
        </React.Fragment>
    );
};

export default SettingsView;
